import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'prefix',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'v3'
      },
      {
        path: 'v1',
        loadComponent: () => import('./v1/v1.component').then(m => m.V1Component)
      },
      {
        path: 'v2',
        loadComponent: () => import('./v2/v2.component').then(m => m.V2Component)
      },
      {
        path: 'v3',
        loadComponent: () => import('./v3/v3.component').then(m => m.V3Component)
      }
    ]
  }
];
